import { Controller } from 'react-hook-form';

import Checkbox, { CheckboxProps } from 'ui/Checkbox';
import { useUpstreamFormPropagation } from 'utils/form';

import { useSankeyFormContext } from '../../contexts/sankeyFormContext';

type Props = Omit<CheckboxProps, 'form'> & {
  field: SankeyFormBooleanField;
};

const FormCheckbox = ({ field, ...props }: Props) => {
  const { form } = useSankeyFormContext();

  // Propagate the checkbox value instantly to the upstream form (if it exists).
  useUpstreamFormPropagation(field, 0);

  return (
    <Controller
      name={field}
      control={form.control}
      render={({ field }) => (
        <Checkbox
          id={field.name}
          checked={!!field.value}
          onChange={field.onChange}
          w="fit-content"
          {...props}
        />
      )}
    />
  );
};

export default FormCheckbox;
